var map = {
	"./additionally.svg": "7cef",
	"./api.svg": "90ce",
	"./arrow.svg": "1ba4",
	"./arrowLeft.svg": "5ade",
	"./arrowRight.svg": "dfac",
	"./arrowWidgetDown.svg": "3d0c",
	"./arrowWidgetUp.svg": "d201",
	"./back.svg": "8eed",
	"./balance.svg": "1fcf",
	"./bank-transfer.svg": "b024",
	"./big-play.svg": "9aa9",
	"./big-plus.svg": "efb2",
	"./booked-slot.svg": "d37d",
	"./burger-mobile.svg": "0bfa",
	"./burger.svg": "443c",
	"./camera.svg": "be83",
	"./cancel.svg": "db4d",
	"./change-status.svg": "c024",
	"./check.svg": "8c0f",
	"./chevron.svg": "1eef",
	"./clients.svg": "3c80",
	"./clock.svg": "b5e0",
	"./close-cicle.svg": "7e3f",
	"./close.svg": "b3de",
	"./company.svg": "5d8c",
	"./confirmed.svg": "b6b3",
	"./copy.svg": "b7ae",
	"./dashboard.svg": "cd2e",
	"./date.svg": "8c7a",
	"./datetime.svg": "1003",
	"./docs-thin.svg": "3a17",
	"./docs.svg": "3154",
	"./dots.svg": "16c4",
	"./dragger.svg": "03cb",
	"./edit-2.svg": "41f0",
	"./edit.svg": "36a6",
	"./edited-slot.svg": "9cd7",
	"./email.svg": "83e5",
	"./error-status.svg": "ca79",
	"./error.svg": "9162",
	"./exit.svg": "156a",
	"./eye.svg": "61b5",
	"./facebook.svg": "9bf3",
	"./facebook_messenger.svg": "f2f9",
	"./feedback.svg": "1f66",
	"./filter.svg": "2ec2",
	"./gift.svg": "6259",
	"./google.svg": "8703",
	"./grid.svg": "97a2",
	"./history-changes-2.svg": "0a48",
	"./history-changes.svg": "5d88",
	"./history-payment-3.svg": "bc98",
	"./history-payment.svg": "7a84",
	"./info-status.svg": "8293",
	"./instagram.svg": "1498",
	"./integration.svg": "ef46",
	"./isDone.svg": "0f79",
	"./list.svg": "d162",
	"./lock-1.svg": "ae406",
	"./lock.svg": "00284",
	"./lock2.svg": "cc8f",
	"./logo-min.svg": "0fbf",
	"./logo-mobile-path.svg": "f80d",
	"./logo.svg": "de58",
	"./logout.svg": "261f",
	"./mail.svg": "90a7",
	"./mail2.svg": "0445",
	"./menu.svg": "e927",
	"./messeger.svg": "f198",
	"./minus.svg": "4383",
	"./news.svg": "f19c",
	"./news2.svg": "b96e",
	"./nophoto.svg": "3f76",
	"./notif.svg": "15d0",
	"./notifications.svg": "b2aa",
	"./notifications2.svg": "0c1a",
	"./odnoklassniki.svg": "3fdc",
	"./ok.svg": "0fb1",
	"./overlap.svg": "9e5b",
	"./pay-success.svg": "4734",
	"./pay.svg": "8034",
	"./payments.svg": "4bac",
	"./person.svg": "7a27",
	"./phone.svg": "d7fc",
	"./play.svg": "373a",
	"./plus.svg": "0259",
	"./promo.svg": "451e",
	"./question.svg": "03f0",
	"./refund.svg": "2c76",
	"./reload.svg": "9797f",
	"./reserves.svg": "d3fc",
	"./schedule.svg": "6695",
	"./schedule2.svg": "efbf",
	"./search.svg": "8b4c",
	"./settings.svg": "721d",
	"./settings2.svg": "d1d5",
	"./sms.svg": "68f0",
	"./socialNetwork.svg": "b025",
	"./success.svg": "27de",
	"./telegram.svg": "5069",
	"./time.svg": "a0f7",
	"./twitter.svg": "deaf",
	"./union.svg": "9894",
	"./viber.svg": "e932",
	"./views.svg": "9926",
	"./vk.svg": "b211",
	"./vk_messenger.svg": "5b53",
	"./waiting.svg": "4626",
	"./warning-outline.svg": "73d8",
	"./whatsapp.svg": "bf8b",
	"./yandex.svg": "9125"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e1fa";